export default "__VITE_ASSET__DSRavavQ__"